export default "__VITE_ASSET__CxeryMIt__"